import React, { useContext } from 'react';
import classNames from 'classnames';
import LeadsContext from '../../../../providers/Leads/Leads.context';
import ListingContext from '../../../../providers/Listing/Listing.context';
import DealContext from '../../../../providers/Deal/Deal.context';
import { BUYERS_ACTIVITY_TRACK_TYPE } from 'models/Lead';
import { MEMBER_ACTIVITY_PAGE } from 'models/MixpanelEvents';
import LeadTimeActivity from '../LeadInformation/components/LeadTimeActivity/LeadTimeActivity.component';

import './LeadActivity.styles.scss';

type LeadActivityProps = {
  className?: string;
};

const LeadActivity: React.FC<LeadActivityProps> = (props) => {
  const { className } = props;

  const { selectedLead } = useContext(LeadsContext);
  const {
    canAccessDataRoom,
    dealRoom: { _id: dealId, name: dealName },
  } = useContext(ListingContext);

  const { leadStagesCopies } = useContext(DealContext);

  const classes = classNames('lead-activity', className);

  return (
    <div className={classes}>
      <LeadTimeActivity
        lead={selectedLead}
        dealId={dealId}
        dealName={dealName}
        dataRoomDisabled={!canAccessDataRoom}
        initialSelectedEventTypes={[BUYERS_ACTIVITY_TRACK_TYPE.PLATFORM]}
        memberActivityPage={MEMBER_ACTIVITY_PAGE.LEAD_BOARD}
        leadStagesCopies={leadStagesCopies}
      />
    </div>
  );
};

export default LeadActivity;
